module.exports = ".bg-red {\n  background-color: #fff;\n  color: #ec1c3e;\n  border-bottom: 1px solid #ec1c3e; }\n  .bg-red img {\n    width: 50%; }\n"